module.exports = __webpack_public_path__ + "img/ic_burger_story.4737ee22.svg";